// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <div>
    <div>
      <v-btn text @click.stop="addItem()"><v-icon>add</v-icon>Add Antenna</v-btn>
    </div>
    <v-data-table
      v-bind:headers="headers"
      :items="items"
      hide-default-footer
      no-data-text="No antenna definitions"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            {{ props.index }}
          </td>
          <td class="text-xs-left">
            <v-edit-dialog
            lazy
            > {{ props.item.xycoordinates[0] }}
              <template v-slot:input>
                <v-text-field
                  v-model.number="props.item.xycoordinates[0]"
                  label="X"
                  single-line
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-left">
            <v-edit-dialog
            lazy
            > {{ props.item.xycoordinates[1] }}
              <template v-slot:input>
                <v-text-field
                  v-model.number="props.item.xycoordinates[1]"
                  label="Y"
                  single-line
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td class="text-xs-left">
            <v-edit-dialog
            lazy
            > {{ getMapName(props.item.map)}}
              <template v-slot:input>
                <v-autocomplete
                  label="Map"
                  item-text="name"
                  item-value="_id"
                  single-line
                  v-bind:items="maps"
                  v-model="props.item.map"
                  :men-props="'auto'"
                ></v-autocomplete>
              </template>
            </v-edit-dialog>
          </td>
          <td style="width: 1px; padding: 0px; white-space:nowrap;">
            <v-btn title="Delete" icon text v-if="canModify" @click="deleteItem(props.index)"><v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import {checkPermission} from 'vue-common/components/user'
import {PERMISSIONS} from 'vue-common/components/constants'
import {LookupMixin} from '@/shared/mixins'

export default {
  mixins: [LookupMixin],

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      items: this.value,
      editCert: {
        xycoordinates: []
      },
      maps: [],
      formValid: true,
      showDialog: false,
      headers: [
        {
          text: 'Antenna',
          value: 'antenna',
          sortable: false
        },
        {
          text: 'X',
          value: 'xycoordinates[0]'
        },
        {
          text: 'Y',
          value: 'xycoordinates[1]'
        },
        {
          text: 'Map',
          value: 'map',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ]
    }
  },

  created () {
    ApiRequests.getMaps(this.selectedSite._id).then((response) => {
      this.maps = response.data
    })
    this.checkVal()
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'endpoints', PERMISSIONS.MODIFY)
    }
  },

  watch: {
    items () {
      this.$emit('input', this.items)
    },

    value (val) {
      if (this.value === null) {
        this.items = []
      } else {
        this.items = this.value
      }
    }
  },

  methods: {
    addItem: function () {
      this.items.push({
        map: '',
        xycoordinates: []
      })
    },

    checkVal: function () {
      if (this.value === null) {
        this.items = []
      } else {
        this.items = this.value
      }
    },

    deleteItem: function (index) {
      this.items.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tabs/EndpointAntennas.vue